/** The Statistics filter row's custom date range and recurring-hours filter. */
export const translationStatistics_da_hours = {
  hoursFilterRecurring: "Filtrér tilbagevendende klokkeslæt",
  hoursFilterTimezone: "Tidszone",
  hoursFilterMondayFriday: "Mandag–fredag",
  hoursFilterEveryDay: "Hver dag",
  hoursFilterWeekendHours: "Brug andre klokkeslæt i weekenden",
  hoursFilterSaturdaySunday: "Lørdag–søndag",
  hoursFilterHowHoursApply: "Sådan bruges klokkeslæt",
  hoursFilterHowHoursApplyBody:
    "Start medtages; slut medtages ikke. Et tidligere sluttidspunkt går over midnat; ens tider betyder hele dagen. Hver kalenderdag bruger sit eget interval, også om morgenen. Samtalestatistik bruger samtalens start; livechat følger samtalen; emailforbrug bruger afslutningstidspunktet.",
  hoursFilterCommerceUnavailable:
    "Handels- og chatåbningsmålinger er ikke tilgængelige med dette samtalefilter. Ryd filteret for at generere rapporter eller eksportere; planlagte rapporter beholder deres eget omfang.",
  hoursFilterAllDay: "Hele dagen",
  hoursFilterFrom: "Fra",
  hoursFilterUntil: "Til",
  statisticsDateRange: "Datointerval",
  statisticsPickDateRange: "Vælg datointerval",
};
